import React from 'react';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';
import CellTypePopup from '../../../../../element/table/cellTypes/CellTypePopup';

type CellTypePopupContainerProps = {
    isPopupOpen: boolean;
    buttonSelector: string;
    closePopup: () => void;
    showArrow?: boolean;
    lastClickedType: string;
    setLastClickedType: (type: string) => void;
    locale: string;
    activeCellType: string;
};

const CellTypePopupContainer: React.FC<CellTypePopupContainerProps> = ({ isPopupOpen, ...props }) => (
    <ToolbarPopup
        {...props}
        popupId={PopupIds.CELL_TYPE}
        ignoredClicksSelector=".CustomSelectInput, .select-option"
        className="CellTypePopup"
        showArrow={true}
    >
        <CellTypePopup {...props} closePopup={null} />
    </ToolbarPopup>
);

export default CellTypePopupContainer;
